import React from "react";

import { ReactComponent as EmptyFolderIcon } from "assets/images/app_svg/empty_folder_custom_restore.svg";

function emptyFolder() {
  return (
    <div className="fs_empty_screen">
      <div className="fses_icon">
        <EmptyFolderIcon />
      </div>
      <div className="fses_text">This folder is empty</div>
    </div>
  );
}

export default emptyFolder;
